<app-shipping-backlog-filter
(shippingBacklogOverviewFilterChanges)="setShippingBacklogOverviewFilter($event)"></app-shipping-backlog-filter>
@if ({
  isLoading: isLoading$ | async,
  shippingBacklogItems: shippingBacklogItems$ | async,
  dateFormat: dateFormat$ | async
  }; as type) {
  @if (type.shippingBacklogItems && !type.isLoading && type.dateFormat) {
    <!-- BODY -->
    <div class="cx-order-history-body">
      @if (type.shippingBacklogItems.pagination.totalResults > 0) {
        <!-- Select Form and Pagination Top -->
        <div class="cx-order-history-sort top row">
          <div class="cx-order-history-form-group form-group col-sm-12 col-md-4 col-lg-4">
            <div class="sort-label"><i class="fas fa-caret-down"></i>&nbsp;{{ 'filteredDocumentsResult.sortLabel' | cxTranslate }}</div>
            <cx-sorting
              [sortOptions]="type.shippingBacklogItems.sorts"
              [sortLabels]="getSortLabels() | async"
              (sortListEvent)="changeSortCode($event)"
              [selectedOption]="type.shippingBacklogItems.pagination.sort"></cx-sorting>
          </div>
          @if (type.shippingBacklogItems.pagination.totalPages > 1) {
            <div
              class="cx-order-history-pagination col-sm-12 col-md-4 col-lg-4">
              <cx-pagination [pagination]="type.shippingBacklogItems.pagination"
              (viewPageEvent)="pageChange($event)"></cx-pagination>
            </div>
          }
        </div>
        <!-- TABLE -->
        <table class="table cx-order-history-table">
          <thead class="cx-order-history-thead-mobile">
            <th scope="col">{{ 'shippingBacklog.shippingBacklogItem.orderNumber' | cxTranslate }}</th>
            <th scope="col">{{ 'shippingBacklog.shippingBacklogItem.orderPositionNumber' | cxTranslate }}</th>
            <th scope="col">{{ 'shippingBacklog.shippingBacklogItem.oemNumber' | cxTranslate }}</th>
            <th scope="col">{{ 'shippingBacklog.shippingBacklogItem.requestedQuantity' | cxTranslate }}</th>
            <th scope="col">{{ 'shippingBacklog.shippingBacklogItem.expectedDeliveryDate' | cxTranslate }}</th>
            <th scope="col">{{ 'shippingBacklog.shippingBacklogItem.status' | cxTranslate }}</th>
          </thead>
          <tbody>
            @for (shippingBacklogItem of type.shippingBacklogItems.items; track shippingBacklogItem) {
              <tr>
                <td attr.data-label="{{ 'shippingBacklog.shippingBacklogItem.orderNumber' | cxTranslate }}"
                  class="cx-order-history-number">
                  {{ shippingBacklogItem?.orderNumber }}
                </td>
                <td attr.data-label="{{ 'shippingBacklog.shippingBacklogItem.orderPositionNumber' | cxTranslate }}"
                  class="cx-order-history-number">
                  {{ shippingBacklogItem?.orderPositionNumber }}
                </td>
                <td attr.data-label="{{ 'shippingBacklog.shippingBacklogItem.oemNumber' | cxTranslate }}"
                  class="cx-order-history-number">
                  {{ shippingBacklogItem?.oemNumber }}
                </td>
                <td attr.data-label="{{ 'shippingBacklog.shippingBacklogItem.requestedQuantity' | cxTranslate }}"
                  class="cx-order-history-number">
                  {{ shippingBacklogItem?.requestedQuantity }}
                </td>
                <td attr.data-label="{{ 'shippingBacklog.shippingBacklogItem.expectedDeliveryDate' | cxTranslate }}"
                  class="cx-order-history-date">
                  {{ shippingBacklogItem?.expectedDeliveryDate | cxDate: type.dateFormat }}
                </td>
                <td attr.data-label="{{ 'shippingBacklog.shippingBacklogItem.status' | cxTranslate }}"
                  class="cx-order-history-type-name">
                  {{ shippingBacklogItem?.status }}
                </td>
              </tr>
            }
          </tbody>
        </table>
        <!-- Select Form and Pagination Bottom -->
        <div class="cx-order-history-sort bottom row">
          @if (type.shippingBacklogItems.pagination.totalPages > 1) {
            <div
              class="cx-order-history-pagination">
              <cx-pagination [pagination]="type.shippingBacklogItems.pagination"
              (viewPageEvent)="pageChange($event)"></cx-pagination>
            </div>
          }
        </div>
      } @else {
        <app-no-display-result-notice noticeHeadline="{{ 'filteredDocumentsResult.noResult' | cxTranslate }}"></app-no-display-result-notice>
      }
      <!-- NO RESULT CONTAINER -->
    </div>
  } @else {
    @if (type.isLoading) {
      <div class="cx-spinner">
        <cx-spinner></cx-spinner>
      </div>
    }
  }
}
